module.exports = __webpack_public_path__ + "img/free.8b9793cd.jpg";